import { Col, Row } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Button, Text, TextField, InputOtp } from '../../components';
import { Colors, Utils } from '../../config';
import { AppAction } from '../../store/actions';
// import styles from "./styles";
import login from '../../assets/images/login.png';
import siteLogo from '../../assets/images/logo-text-x.png';
import ButtonLoader from '../../components/Button/ButtonLoader';
import useColors from '../../hooks/useColors';
import { Link } from 'react-router-dom';

const VerifyOTP = () => {
    
    const { colorPrimary, colorSecondary } = useColors();
    const validCompany = useSelector(
        (state) => state?.AppReducer?.validCompany,
    );
    const companyLogo = Utils.getBrandLogoUrl(validCompany) ?? siteLogo;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loader = useSelector((state) => state?.AppReducer.loader);

    const [otp, setOtp] = useState('');

    const validateEmail = () => { };

    const otpvalues = () => { };

    const otpResendHandler = () => {
        const payload = {
            email: localStorage.getItem('email'),
        };
        dispatch(AppAction.EmailVerification(payload));
    };

    const otpHandler = (a) => {
        setOtp(a);
    };

    const otpSubmitHandler = () => {
        dispatch(
            AppAction.OTPVerification(otp, () => {
                navigate('/reset-password');
            }),
        );
    };

    return (
        <Row>
            <Col lg={12} md={12} sm={24} xs={24} className="h-screen">
                <section className="h-full flex">
                    <div className="flex flex-col items-center justify-center px-6 mx-auto md:h-screen lg:py-0">
                        {/* <a href="#" className="mt-3">
                            <img
                                className="xl:w-80 md:w-80 xl:h-32 md:h-32 h-24 w-72 mr-2 object-contain"
                                src={validCompany?.logo[0]?.url ?? siteLogo}
                                alt="logo"
                            />
                        </a> */}
                        <div className={`rounded-full border border-gray-300 drop-shadow-md w-28 h-28 mx-auto my-4 p-1`}>
                            <Link>
                                <img
                                    // style={{ width: '200px', height: '60px' }}
                                    className="mx-auto py-0 object-contain w-full h-full rounded-full"
                                    src={companyLogo}
                                />
                            </Link>
                        </div>
                        <div className="w-full md:mt-0 sm:max-w-md xl:p-0">
                            <div
                                className="pt-3 mx-auto flex items-center flex-col justify-center"
                                style={{}}
                            >
                                <h1 className="mb-3 text-center text-2xl font-bold">
                                    Enter the 4 Digit Code
                                </h1>
                                <p
                                    className="text-center text-sm mb-5"
                                    style={{ color: Colors.Gray }}
                                >
                                    A one-time password (OTP), also known as a
                                    one-time PIN, one-time authorization
                                </p>

                                <div className="space-y-4 md:space-y-6 w-11/12	">
                                    <div>
                                        <InputOtp
                                            value={otp}
                                            onChange={otpHandler}
                                            inputStyle={{
                                                margin: '0 10px',
                                                padding: '0.5rem 1.2rem',
                                                color: Colors.Black,
                                                width: '60px',
                                                fontSize: '2rem',
                                                border: '1px solid #D7DBE8',
                                                backgroundColor: '#F9FAFC',
                                                borderRadius: '7px',
                                                outline: 'none',
                                            }}
                                            containerStyle={{
                                                width: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                            numInputs={'4'}
                                            inputType={'number'}
                                            skipDefaultStyles={true}
                                        />
                                    </div>

                                    <div className="flex items-center justify-center">
                                        <a
                                            href="#"
                                            className="text-sm font-medium"
                                            onClick={otpResendHandler}
                                        >
                                            Didn't receive the code?
                                            <span
                                                style={{ color: colorPrimary }}
                                                className="hover:underline"
                                            >
                                                {' '}
                                                Resend
                                            </span>
                                        </a>
                                    </div>
                                    {/* <button type="submit" disabled={otp?.length == 4 ? false : true} style={{ background: colorSecondary }} onClick={otpSubmitHandler} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">SUBMIT</button> */}
                                    <ButtonLoader
                                        isDisabled={
                                            otp?.length == 4 ? false : true
                                        }
                                        loader={loader}
                                        text={'SUBMIT'}
                                        btnHandler={otpSubmitHandler}
                                        style={{
                                            background: colorPrimary,
                                            color: Colors.White,
                                        }}
                                        className="cursor-pointer w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 h-12 text-base tracking-wider"
                                    />

                                    <div className="flex items-center justify-center mb-3">
                                        <a
                                            href="#"
                                            className="text-sm font-medium text-primary-600 hover:underline"
                                            style={{ color: colorPrimary }}
                                            onClick={() => navigate('/login')}
                                        >
                                            Back to Login
                                        </a>
                                    </div>

                                    <p className="text-xs text-center mt-10">
                                        Copyright 2025{' '}
                                        <span style={{ color: colorPrimary }}>
                                            GuardsConnect
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Col>
        </Row>
    );
};

export default VerifyOTP;
